import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';


@Component({
    selector: 'sched-board',
    templateUrl: './board-member.component.html',
})

export class BoardMemberComponent implements OnInit {
    boardList: any[];
    cols: any[];
    myMember: any = {
        id: null,
        email: '',
        memberName: '',
        phone: ''
    };
    
    userType: string;  // this is userType of logged on user for checking Read-Only
    
    isNewEntry = false;

    displayState: any = {
    workingDiv: false,
    memberDiv: false,
    gridDiv: true,
    editMemberDiv: false,
    saveDisabled: false
    };
      
    constructor(private messageService: MessageService, private confirmationService: ConfirmationService, private schedService: ScheduleService) { }
  
    ngOnInit() {
        this.cols = [
            { field: 'memberName', header: 'Member Name' },
            { field: 'email', header: 'Email Address' },
            { field: 'phone', header: 'Phone' },
        ];
        this.getBoardMemberList();
    }

    getBoardMemberList() {
        // get list of Board Members
        this.displayState.workingDiv = true;
        this.schedService.getBoardMemberList().subscribe(data => {
            if (data) {
                this.boardList = data;
            }
            this.displayState.workingDiv = false;
        });
    }

    onSelect(boardMember: any) {
        // get the board member's data; from grid or from API call??
        //
        // now, display the edit board member form
        //console.log(boardMember);
        this.displayState.gridDiv = false;
        this.displayState.memberDiv = true;
        this.isNewEntry = false;
        // set board member data for display
        this.myMember.id = boardMember.id;
        this.myMember.email = boardMember.email;
        this.myMember.memberName = boardMember.memberName;
        this.myMember.phone = boardMember.phone;
        //
        this.displayState.editMemberDiv = true;
        return true;
      }
        
    newBoardMember() {
        this.displayState.gridDiv = false;
        this.displayState.memberDiv = true;
        this.isNewEntry = true;
        this.displayState.editMemberDiv = true;
        // set board member data for display
        this.myMember.id = 0;
        this.myMember.email = '';
        this.myMember.memberName = '';
        this.myMember.phone = '';
        //
        return true;
    }
    
    saveMember() {
        if (this.validateMemberData() === false ) {
            this.showToast({severity: 'error', summary: '', detail: 'Required items are missing.'});
            return true;
          }
          this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
          // save board member data
          this.schedService.saveBoardMember(this.myMember).subscribe (data => {
            // once we get a response, hide the Edit window
            this.displayState.memberDiv = false;
            this.displayState.editMemberDiv = false;
            this.displayState.saveDisabled = false;
            // display grid div
            this.displayState.gridDiv = true;
            this.showToast({severity: 'success', summary: '', detail: 'Board Member data updated.'});
            // refresh the grid/list
            this.getBoardMemberList();
          });
      
          //
          return true;
    }
      
    validateMemberData() {
        // validate required board member data; base it on value of any element w/ prd-required class??
        //if ((this.myMember.email === '') || (this.myMember.memberName === '')) {
        if ((this.myMember.memberName === '')) {
        return false;
        }
        return true;
    }
    
    deleteBoardMember(boardMember: any) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
            this.schedService.deleteBoardMember(boardMember).subscribe(data => {
                this.showToast({severity: 'success', detail: 'Board Member has been DELETED.', summary: ''});
                this.getBoardMemberList();
            });
            },
            reject: () => {
            this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
            }
        });
    
        return true;
    }
    
    cancelEntry() {
        this.displayState.memberDiv = false;
        this.displayState.editMemberDiv = false;
        this.displayState.gridDiv = true;
        return true;
    }
    
    showToast(msg: Message) {
        this.messageService.add(msg);
    }
    
    showConfirm() {
        this.messageService.clear();
        this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
    }
    
    
    onConfirm() {
        this.messageService.clear('c');
    }
    
    onReject() {
        this.messageService.clear('c');
    }
    
    clear() {
        this.messageService.clear();
    }
      
      
}